import {connect} from 'react-redux'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../../style.css"
import "./maintenance.css"

const MaintenancePage = ({page}) => {

    const {
        mainLogo,
        title,
        description,
        backgroundImage
    } = page;

    return (
            <div className='glob'>
                <>
                    <div className='home-container' style={{backgroundImage: `url(${"../static/images/" + (backgroundImage)}`}}>
                        <Container>
                            <Row className='align-items-center justify-content-left' style={{minHeight: 'calc(100vh - 200px'}}>
                                <Col className='col-12'>
                                    <Row className="home-text1 mb-4 justify-content-center">
                                        <Col className="col-auto">
                                            <img className="logoImg" src={"../static/images/" + (mainLogo)} />
                                        </Col>
                                    </Row>
                                    <Row className="home-text justify-content-center">
                                        <Col style={{textAlign: "center"}}>{title}</Col>
                                    </Row>
                                    <Row className="home-text1 justify-content-center">
                                        <Col style={{textAlign: "center"}}>{description}</Col>
                                    </Row>
                                    <Row className="home-text justify-content-center">
                                        <Col style={{textAlign: "center"}} className="col-2">
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </>
            </div>
    )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {})(MaintenancePage);
